import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import UI from '../ui';
import Utils from '../utils';
import {
	FinalizeConnection,
	Footer,
	FormSection,
	Guidelines,
} from './USPS/components';
import { USPS_CONSTANTS } from './USPS/constants';
import { UspsBusinessBanner } from './USPSBusiness';

const { Link, InlineMessage } = UI;
const { Session, Util } = Utils;

const getIsIDsSaved = onboardingStatus =>
	Boolean(onboardingStatus) &&
	USPS_CONSTANTS.FORM_FIELDS.EPS_ACCOUNT_NUMBER in onboardingStatus &&
	USPS_CONSTANTS.FORM_FIELDS.MID_NUMBER in onboardingStatus &&
	USPS_CONSTANTS.FORM_FIELDS.CRID_NUMBER in onboardingStatus;

const ConnectUSPSBusinessAccountComponent = ({
	onboardingStatus,
	userInfoToken,
	redirectUri,
	onDismiss,
	refetch,
	clearUserInfoToken,
}) => {
	const [isUSPSAccountCreated, setIsUSPSAccountCreated] = useState(false);
	useEffect(() => {
		setIsUSPSAccountCreated(
			!isEmpty(userInfoToken) ||
				(onboardingStatus?.IsOnboarded === true &&
					onboardingStatus?.IsAuctaneOwned === false)
		);
		setIsIDsSaved(getIsIDsSaved(onboardingStatus));
	}, [onboardingStatus, userInfoToken]);

	const [isIDsSaved, setIsIDsSaved] = useState(getIsIDsSaved(onboardingStatus));

	const handleCancel = () => {
		onDismiss();
	};

	return (
		<div className="connect-usps-wrapper">
			<div className="connect-usps-container">
				<div className="subtitle-container">
					<div className="carrier-icon" />
					<div className="subtitle-content">
						<h3>Connect USPS Business Account</h3>
						<p className="subtitle-text">
							Please review the carrier's terms and conditions.
						</p>
					</div>
				</div>
				<h4 className="guidelines-heading">Guidelines</h4>
				<p className="guidelines-sub-text">
					Follow these steps to connect your USPS business account to Auctane.
				</p>
				<InlineMessage
					type="information"
					header="Important Note for Multi-Account Users"
					text="If you already have completed the onboarding process for another account using the same USPS NSA contract, you do not need to complete these steps again for this account."
					canClose={false}
					dataqa="multi-account-note"
					className="multi-account-note"
				/>
				{isIDsSaved && (
					<UspsBusinessBanner
						type={'information'}
						canClose={true}
						show={isIDsSaved}
						onClose={() => {
							Session.savePreferences([
								{
									Name: 'DismissedUspsBusinessApprovalMessage',
									Value: '1',
								},
							]);
						}}
						onLearnMoreClick={() => {
							// Could open external link or modal here
							// TODO: add link to learn more about USPS Business Accounts when COP documentation is ready
						}}
					/>
				)}
				<Guidelines isUSPSAccountCreated={isUSPSAccountCreated} />
				<FinalizeConnection
					isUSPSAccountCreated={isUSPSAccountCreated}
					redirectUri={redirectUri}
				/>
				<FormSection
					onboardingStatus={onboardingStatus}
					userInfoToken={userInfoToken}
					isIDsSaved={isIDsSaved}
					setIDsSaved={setIsIDsSaved}
					refetch={refetch}
					isUSPSAccountCreated={isUSPSAccountCreated}
					clearUserInfoToken={clearUserInfoToken}
				/>
				<div>
					<Link
						className="usps-business-link"
						onClick={() => {
							Util.openHelpCenter('41331739738779');
						}}
					>
						Learn more about EPAs
						<span className="external-link-icon" />
					</Link>
				</div>
			</div>
			<Footer onCancel={handleCancel} />
		</div>
	);
};

export const ConnectUSPSBusinessAccount = ConnectUSPSBusinessAccountComponent;
